/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Manila')
dayjs.extend(isSameOrBefore)

import { SHIRT_COLOR } from '../constants/employees'
import { FAMILY_TSHIRT_SIZES } from '../constants/models'

export const filteredData = (items, startTimestamp, isFree) => {
  return items?.filter((p) => {
    if (isFree) {
      if (startTimestamp !== null) return p.createdAt >= startTimestamp
      return true
    }

    if (
      p !== null &&
      (p.order?.paymentMode === 'PAYPAL' ||
        p.order?.paymentMode === 'MANUAL' ||
        (['CARD', 'GCASH', 'PAYMAYA', 'GRAB_PAY'].includes(
          p.order?.paymentMode,
        ) &&
          p.order?.status === 'payment.paid'))
    ) {
      if (startTimestamp !== null) return p.createdAt >= startTimestamp

      return true
    }
    return false
  })
}

export const processFormParticipantsData = (items, tshirtTotal, categories) => {
  const hasCategories = Object.keys(categories).length > 0

  items.forEach((item, index, theItems) => {
    const newTshirtCount = {}

    Object.keys(FAMILY_TSHIRT_SIZES).forEach((size) => {
      ;(hasCategories ? Object.values(categories) : SHIRT_COLOR).forEach(
        (groupName) => {
          newTshirtCount[`${size}_${groupName}`] = 0
        },
      )
    })

    const parsed = JSON.parse(JSON.parse(item.tshirtCount)).map((cnt: any) => ({
      size: cnt.size,
      quantity: parseInt(cnt.quantity),
      ...(hasCategories && {
        category: categories[cnt.categoryId],
      }),
      ...(!hasCategories && {
        color: cnt.color,
      }),
    }))

    theItems[index].tshirtCount = JSON.stringify(parsed)
    theItems[index].tshirtCountTotal = 0
    parsed.forEach((cnt) => {
      newTshirtCount[
        `${cnt.size}_${hasCategories ? cnt.category : cnt.color}`
      ] += parseInt(cnt.quantity)
      theItems[index].tshirtCountTotal += parseInt(cnt.quantity)
    })
    theItems[index].tshirtCountArr = newTshirtCount

    if (!(item.participantId in tshirtTotal))
      tshirtTotal[item.participantId] = {
        createdAt: item.createdAt,
        tshirtCount: parsed,
      }
    else {
      if (
        dayjs(tshirtTotal[item.participantId].createdAt).isSameOrBefore(
          dayjs(item.createdAt),
        )
      ) {
        tshirtTotal[item.participantId] = {
          createdAt: item.createdAt,
          tshirtCount: parsed,
        }
      }
    }
  })

  return { items, tshirtTotal }
}

export const processSummaryTshirtCount = (tshirtTotal, categories) => {
  const hasCategories = Object.keys(categories).length > 0
  const summaryTshirtTotal = {}
  Object.keys(FAMILY_TSHIRT_SIZES).forEach((size) => {
    ;(hasCategories ? Object.values(categories) : SHIRT_COLOR).forEach(
      (groupName) => {
        summaryTshirtTotal[`${size}_${groupName}`] = 0
      },
    )
  })

  Object.values(tshirtTotal).forEach((total: any) => {
    total.tshirtCount.forEach((tcnt) => {
      const key = `${tcnt.size}_${hasCategories ? tcnt.category : tcnt.color}`
      if (!(key in summaryTshirtTotal)) summaryTshirtTotal[key] = 0

      summaryTshirtTotal[key] += parseInt(tcnt.quantity)
    })
  })

  return summaryTshirtTotal
}
